/* eslint-disable */
export default function forgetPasswordValidation(e, msgContainer, key) {
    msgContainer[key] = [];
    msgContainer['isError'] = false;
    let insertedEmail = e.target.value;
    let res1 =  /\S+@\S+\.\S+/.test(insertedEmail);
    if(insertedEmail.length < 1){
        msgContainer[key].push('*Required');
        msgContainer['isError'] = true;
    }else if(key === 'email' && !res1){
        msgContainer[key].push('* Email must be alpha with space only');
        msgContainer['isError'] = true;
    }
}
